import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import SingleVideo from "./SingleVideo";

interface FeelingSelectProps {
  moodImages: any;
  relevantMoods: any;
  imagesReady: any;
}

const Feeling = ({
  moodImages,
  relevantMoods,
  imagesReady,
}: FeelingSelectProps) => {
  const { t } = useTranslation();

  const moodGenitiveLabels = useMemo(
    () =>
      moodImages.map(
        (moodImage: { moodGenitive: any }) => moodImage.moodGenitive
      ),
    [moodImages]
  );

  return (
    <div
      style={{
        transition: "opacity 0.3s ease-in-out",
        backgroundColor: "#F2F2F7",
      }}
    >
      <div style={{ width: "100%", paddingTop: "16px" }}>
        <SingleVideo
          moodImages={moodImages}
          relevantMoods={relevantMoods}
          videosReady={imagesReady}
        />
      </div>
    </div>
  );
};

export default Feeling;
